import React, {FC} from 'react';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {AmazonType} from 'desktop/types/amazonV2Type';
import {CompleteOrderType} from 'types/completeOrderType';

import {PaymentMoneyBackGuaranteeConnected} from '../../../paymentMoneyBackGuarantee/paymentMoneyBackGuarantee';
import {PaymentStepAgreement} from '../../../paymentStepAgreement/paymentStepAgreement';
import {AmazonButtons} from '../amazonButtons/amazonButtons';
import {AmazonData} from '../amazonData/amazonData';
import {AmazonErrors} from '../amazonErrors/amazonErrors';

import s from './amazonAuth.scss';

type PropsType = {
    amazon: AmazonType;
    completeOrder: CompleteOrderType;
    isLoadingSendOrder: boolean;
    isLoadingOrderReviewTotals: boolean;
    shippingMethodsStatus: string;
    onSave: () => void;
    onSend: () => void;
};

/**
 * Render content if amazon auth
 */
export const AmazonAuth: FC<PropsType> = React.memo(
    ({
        amazon,
        completeOrder,
        isLoadingOrderReviewTotals,
        isLoadingSendOrder,
        onSave,
        onSend,
        shippingMethodsStatus,
    }) => {
        const isFacelift = useFeature('dCheckoutFacelift');

        const hasError =
            Boolean(completeOrder.errors?.length) ||
            Boolean(completeOrder.error) ||
            Boolean(amazon.error);
        const isLoadingSendOrderButton =
            isLoadingSendOrder ||
            amazon.sessionInfo.isLoading ||
            !amazon.paymentReady ||
            isLoadingOrderReviewTotals ||
            shippingMethodsStatus !== 'FULFILLED';

        return (
            <div className={classNames({[s.innerWrapper]: isFacelift})}>
                <AmazonData
                    accessToken={amazon.accessToken}
                    isPaymentConfirmed={amazon.paymentConfirmed}
                    paymentPreferences={amazon.sessionInfo.data?.paymentPreferences}
                    shippingAddress={amazon.sessionInfo.data?.shippingAddress}
                />
                <AmazonErrors completeOrder={completeOrder} savePaymentError={amazon.error} />
                <AmazonButtons
                    hasError={hasError}
                    isLoadingSendOrderButton={isLoadingSendOrderButton}
                    isPaymentConfirmed={amazon.paymentConfirmed}
                    isPaymentReady={amazon.paymentReady}
                    onSave={onSave}
                    onSend={onSend}
                />
                <PaymentMoneyBackGuaranteeConnected />
                <PaymentStepAgreement />
            </div>
        );
    },
);

AmazonAuth.displayName = 'AmazonAuth';
